import React from 'react';

import { FeatureFlagsManager, Flag } from '../../utils/core/feature-flags-manager';

const subscribe = (onChange: () => void) => FeatureFlagsManager.instance.subscribe(onChange);

/**
 * Returns whether the flag is enabled, and re-renders when it's turned on or off in the flags
 * manager. Use it for a flag that should take effect without a reload.
 */
export const useFeatureFlag = (flag: Flag) =>
  React.useSyncExternalStore(subscribe, () => FeatureFlagsManager.instance.isEnabled(flag));
